module.exports = __webpack_public_path__ + "static/media/quack-image-transparent.7793c88d.png";